import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { User } from '@app/shared/interfaces';
import { BookingFlowService } from '@app/shared/services/booking-flow/booking-flow.service';

@Component({
  standalone: false,
  templateUrl: './connect-booking-flow.component.html',
  styleUrls: ['./connect-booking-flow.component.scss'],
})
export class ConnectBookingFlowComponent implements OnInit {
  allowedRoutes: string[] = [
    // 'start',
    'requirements',
    'requirements-fail',
    'booking-widget',
    'property-ids',
    'review-properties',
    'set-markup',
    'done',
  ];

  phase:
    | 'start'
    | 'requirements'
    | 'requirements-fail'
    | 'booking-widget'
    | 'property-ids'
    | 'review-properties'
    | 'set-markup'
    | 'done' = 'requirements';

  user: User = this.authService.getUserDetails();

  propertyIds = [];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly authService: AuthenticationService,
    private bookingFlowService: BookingFlowService
  ) {
    this.route.params.subscribe((params) => {
      if (this.allowedRoutes.includes(params.path)) {
        this.phase = params.path;
      }
    });
  }

  ngOnInit(): void {
    if (this.bookingFlowService.propertyIds.length > 0) {
      this.propertyIds = this.bookingFlowService.propertyIds;
    }
  }

  handlePhase(event) {
    this.phase = event;
  }

  initPropertyIdsScreen() {
    this.router.navigate(['/accounts/new/booking/property-ids']);
  }

  initReviewPropertiesScreen(propertyIds: any[]) {
    this.propertyIds = propertyIds;
    this.bookingFlowService.propertyIds = propertyIds;
    this.router.navigate(['/accounts/new/booking/review-properties']);
  }

  initPricingScreen(propertyIds: any[]) {
    this.propertyIds = propertyIds;
    this.bookingFlowService.propertyIds = propertyIds;
    this.router.navigate(['/accounts/new/booking/set-markup']);
  }

  setMarkupCompleted() {
    this.bookingFlowService.clearState();
    this.router.navigate(['/accounts/new/booking/done']);
  }
}
